import {Component, Input, OnInit} from '@angular/core';
import {PatientConsultationListItem} from '@models/data/patient-consultations/PatientConsultationListItem';
import {PatientConsultationService} from '@services/core/patient-consultation/patient-consultation.service';
import {PatientConsultation} from '@models/data/patient-consultations/PatientConsultation';
import {ModalService} from '@services/helpers/modal/modal.service';
import {TenantService} from '@services/core/tenant/tenant.service';
import {IconsDefinitionHelper} from '@shared/common/definition-helper';
import {ViewPatientService} from '@services/helpers/patient/view-patient.service';
import {PatientWithNavigationProperties} from '@models/data/patient/Patient';
import {hasValue} from '@shared/utils/helpers';
import { LocalizeTextPipe } from '@shared/pipes/localize-text/localize-text.pipe';
import { SmallListItemComponent } from '../../../../shared/components/small-list-item/small-list-item.component';

import { CircleButtonComponent } from '../../../../shared/components/buttons/circle-button/circle-button.component';
import { IconComponent } from '../../../../shared/components/icon/icon.component';
import { CardInnerComponent } from '../../../../shared/components/cards/card-inner/card-inner.component';

@Component({
    selector: 'app-patient-consultations',
    templateUrl: './patient-consultations.component.html',
    styleUrls: ['./patient-consultations.component.scss'],
    standalone: true,
    imports: [CardInnerComponent, IconComponent, CircleButtonComponent, SmallListItemComponent, LocalizeTextPipe]
})
export class PatientConsultationsComponent extends IconsDefinitionHelper implements OnInit {
  loading$ = true;
  tenantId: string = null;
  patientConsultations: PatientConsultationListItem[] = [];

  patientValue: PatientWithNavigationProperties = null;

  constructor(
    private patientConsultationService: PatientConsultationService,
    private modalService: ModalService,
    private viewPatientService: ViewPatientService,
    private tenantService: TenantService
  ) {
    super();

    this.tenantId = this.tenantService.selectedTenantValue.id;
  }

  ngOnInit(): void {
    if (hasValue(this.viewPatientService.patientValue)) {
      this.patient = this.viewPatientService.patientValue;
    }
  }

  @Input() set patient(patient: PatientWithNavigationProperties) {
    this.patientValue = patient;
    this.retrieveConsultationNotes();
  }

  /**
   * Retrives the consultation notes by the patientPractitionerId
   * @private
   */
  private retrieveConsultationNotes(): void {
    this.loading$ = true;
    // const patientFitMedProfileId = this.viewPatientService.patientValue.fitMedProfile.id;

    // this.patientConsultationService.listFromSpecificTenantByPatientId(patientFitMedProfileId, this.tenantId).then(r => {
    //   this.patientConsultations = r;
    //   this.loading$ = false;
    // });
  }

  async openPatientConsultModal(consultation: PatientConsultation = null): Promise<void> {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const {PatientConsultationFormComponent} = await import('@app/clinician-dashboard/shared/components/patient-consultations/patient-consultation-form/patient-consultation-form.component');

    const updating = consultation !== null;

    const modalData = {
      updating,
      updatingConsult: consultation,
      tenantId: this.tenantId,
      // patientFitMedProfileId: this.viewPatientService.patientValue.fitMedProfile.id
    };

    this.modalService.open(PatientConsultationFormComponent, modalData);

    this.modalService.onClose.subscribe(onCloseSubject => {
      if (onCloseSubject.closed) {
        if (onCloseSubject.content.updateRequired) {
          this.retrieveConsultationNotes();
        }
      }
    });
  }
}
